// ** Authentification
export const GET_USER_AUTHORIZATION = '/direct'

// ** Support Case
export const GET_ALL_CASES = '/tickets/list/'
export const CREATE_NEW_CASE = '/tickets/create'
export const GET_CASE = '/tickets/'
export const UPDATE_CASE = '/tickets/update/'
